module.exports = __webpack_public_path__ + "img/table-tennis.2dc31e7b.svg";